import { getFirebaseAuth } from "@web/utils/firebase/initializeFirebase";
import { signOut } from "firebase/auth";

export async function firebaseLogout(): Promise<void> {
  await signOut(getFirebaseAuth());
}
